export const paginate = (data, pageSize, selectedPage) => {
    return data.slice((selectedPage - 1) * pageSize, selectedPage * pageSize)
}

const getFieldValue = (object, field) => {
    let left = field;
    let enteredField = object;
    do {
        let selectedField = left;
        const subIndex = left.indexOf('.')
        if (subIndex !== -1) {
            selectedField = left.substring(0, subIndex);
            left = left.substring(subIndex + 1, left.length);
        }
        else {
            left = "";
        }

        enteredField = enteredField[selectedField];
        if (Array.isArray(enteredField)) {
          /* eslint-disable-next-line no-loop-func */
          enteredField = enteredField.map(x => getFieldValue(x, left));
          left = "";
        }
    } while (left.length > 0 && !!enteredField);

    return enteredField;
}

const compare = (type, keyword, value) => (
  (value === keyword) ||
  (type === 'contain' && value?.toString()?.toLowerCase()?.includes(keyword?.toLowerCase())) ||
  (type === 'equal' && value?.toString()?.toLowerCase() === keyword?.toLowerCase())
)

export const filterData = (keyword, data, fields, type) => {
    return (!!keyword || type === 'equal') ? (
        data.filter((item) => {
            let res = false

            fields.forEach((field) => {
                const val = getFieldValue(item, field)
                if (Array.isArray(val)) {
                  res = res || val.some(x => !!compare(type, keyword, x));
                }
                else {
                    res = res || !!compare(type, keyword, val);
                }
            })

            return res
        })
    ) : data
}

const dynamicSort = (property, type) => {
    let p = property
    let sortOrder = 1;
    if (p[0] === "-") {
        sortOrder = -1;
        p = p.substr(1);
    }

    return function (a, b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        const valA = getFieldValue(a, p)
        const valB = getFieldValue(b, p)
        let result = (valA < valB);
        if (result) {
            result = -1
        }
        else {
            result = ((valA > valB) ? 1 : 0);
        }
        return result * sortOrder * (type === 'asc' ? 1 : -1);
    }
}

export const orderData = (data, orderField, orderType = 'asc') => {
    return data.sort(dynamicSort(orderField, orderType))
}

export const getIndex = (value, arr, prop) => {
    for (let i = 0; i < arr.length; i += 1) {
        if (arr[i][prop] === value) {
            return i;
        }
    }
    return -1;
};

export const pageSizes = [10, 20, 50, 100, 250, 500, 1000];

export const pick = (obj, keys) => {
  return keys.map(k => k in obj ? {[k]: obj[k]} : {})
             .reduce((res, o) => Object.assign(res, o), {});
}

export const pickExcept = (obj, keys) => {
  const vkeys = Object.keys(obj)
      .filter(k => !keys.includes(k));
  return pick(obj, vkeys);
}